import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import useForm from '../utils/useForm';

const useBankAccountForm = (onSubmit, values, isLender, isLenderUserRole) => {
  const { t } = useTranslation();

  const fields = useMemo(() => {
    const readOnly =
      values?.billcom_id || values?.billcom_alt_id || isLenderUserRole;

    return [
      {
        title: t(
          'AddOrEditPage.AddOrEditLoan.Sections.BankAccount.Bank Account'
        ),
        fields: [
          {
            title: t('common.forms.labels.Bank Name'),
            name: 'bank_name',
            type: 'text',
            required: true,
            readOnly,
          },
          {
            title: t('common.forms.labels.Name on account'),
            name: 'name_on_account',
            type: 'text',
            required: true,
            readOnly,
          },
          {
            title: t('common.forms.labels.Account number'),
            name: 'account_number',
            type: 'bankAccountNumber',
            required: true,
            readOnly,
          },
          {
            title: t('common.forms.labels.Routing number'),
            name: 'routing_number',
            type: 'text',
            required: true,
            readOnly,
          },
          {
            title: t('common.forms.labels.Type'),
            name: 'type',
            type: 'select',
            options: [
              {
                value: 'checking',
                label: t('common.forms.options.Checking'),
              },
              { value: 'savings', label: t('common.forms.options.Savings') },
            ],
            required: true,
            readOnly,
          },
          {
            title: t('common.forms.labels.Personal or business'),
            name: 'personal_type',
            type: 'select',
            options: [
              {
                value: 'personal',
                label: t('common.forms.options.Personal'),
              },
              { value: 'business', label: t('common.forms.options.Business') },
            ],
            required: true,
            readOnly,
          },
          {
            title: 'Function',
            name: 'function',
            type: 'select',
            isHidden: () => !isLender,
            options: [
              {
                value: 'payment',
                label: t('common.forms.options.Payment'),
              },
              {
                value: 'custodial',
                label: t('common.forms.options.Custodial'),
              },
            ],
            required: isLender,
            readOnly,
          },
          {
            title: t('common.forms.labels.ACH Description'),
            name: 'ach_description',
            type: 'text',
            isHidden: () => !isLender,
            readOnly,
            tooltip: () => {
              return readOnly ? '' : t('common.forms.tooltips.ACH Description');
            },
          },
        ],
      },
    ];
  }, [
    values?.billcom_id,
    values?.billcom_alt_id,
    isLenderUserRole,
    t,
    isLender,
  ]);

  return useForm({ fields, onSubmit, values });
};

export default useBankAccountForm;
